{{#> elements/_dt}}
  {{> elements/_label id="opt_in" }}
{{/elements/_dt}}
<dd>
  {{> elements/_input type="radio" value="Yes" checked="true" id="opt_in_yes" }}
  <label for="opt_in_yes">Yes</label>
</dd>
<dd>
  {{> elements/_input type="radio" value="No" id="opt_in_no" }}
  <label for="opt_in_no">No</label>
</dd>
